import { IContact } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getContactPhone } from './getContactPhone'

export const getCompanyContactData = (contact?: IContact) => {
  if (!contact) {
    return {}
  }

  const primaryContactPhoneData = getContactPhone(contact)

  return {
    CompanyContactEmail: contact.Email,
    CompanyContactWorkPhonePrefix: primaryContactPhoneData.code,
    CompanyContactWorkPhone: primaryContactPhoneData.phone,
  }
}
